export default "__VITE_PUBLIC_ASSET__b08c84fb__"